import Vue from 'vue';
import WalletBar from '../../parts/WalletBar.vue';
import Theme from '../../../raccoonTheme';
import { MUTATION_TYPES } from '../../../lib/mutationTypes';
import MessageDialog from "../../parts/MessageDialog";
import ToolBar from "../../parts/ToolBar.vue";
export default Vue.extend({
    components: {
        ToolBar,
        MessageDialog, WalletBar
    },
    name: "SendMessage",
    data() {
        return {
            items: [
                {
                    image: 'icon_message_standard.png',
                    title: this.$t('send.message_standard_title'),
                    message: this.$t('send.message_standard_message'),
                    encryption: false,
                },
                {
                    image: 'icon_message_encryption.png',
                    title: this.$t('send.message_encryption_title'),
                    message: this.$t('send.message_encryption_message'),
                    encryption: true,
                },
            ],
            styles: {
                icon: {
                    width: "64px",
                    height: "64px",
                    borderRadius: "5px",
                    border: "2px solid " + Theme.primary,
                    padding: "8px",
                    marginTop: "8px"
                }
            },
            message: this.$store.state.sendMessage,
            showMessageDialog: false,
            showNoPublicKeyDialog: false,
        };
    },
    methods: {
        openMessageDialog(encryption) {
            if (encryption && this.$store.state.receiverPublicKey.length === 0) {
                this.showNoPublicKeyDialog = true;
                return;
            }
            this.$store.commit(MUTATION_TYPES.SET_MESSAGE_ENCRYPTION, encryption);
            this.showMessageDialog = true;
        },
        getMessageBytes() {
            return encodeURIComponent(this.message).replace(/%../g, "x").length;
        },
        completeMessageInput() {
            this.$store.commit(MUTATION_TYPES.SET_SEND_MESSAGE, this.message);
            this.$store.commit(MUTATION_TYPES.SET_BACK_PATH_FROM_SEND_CONFIRMATION, this.$router.currentRoute.path);
            this.$router.push('/send/confirmation');
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/send/SendMessage.vue
// module id = 654
// module chunks = 1